import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@ppl/ui';
import {  ListTableComponent  } from '@ppl/ui';
import { SectionsService } from '../../../../services/sections.service';
import { ReferralDataService } from '../../../../services/referral-data.service';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { STATIC_DATA } from '../../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { AllowListAuthStore } from '../../../../shared/authorization/allow-list-auth.store';
import { ProcessCode } from '../../../../interfaces/payroll.model';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { ClaimsService } from '../../../../services/claims.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-process-code-list',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './process-code-list.component.html',
  styleUrl: './process-code-list.component.css',
})
export class ProcessCodeListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_PROCESS_CODE_DATA;
  pageId: string = PAGE_CONSTANTS.PROCESS_CODE_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  isReadOnly = false;
  programName!: string;
  lazyLoad = true;

  constructor(private router: Router, private sectionService: SectionsService, private referralDataService: ReferralDataService,
    private userService: UserService, private sharedDataService: SharedDataService,
    private claimsService: ClaimsService,
    private allowListStore: AllowListAuthStore
  ) {
  }

  onAddProcessCode() {
    this.sectionService.setFlow('processCode');
    this.router.navigate(['/home/processCode', 'add']);
  }

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
  }

  rowClicked(rowDetail: ProcessCode) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('processCode');
    this.sectionService.setFlow('processCode');
    this.userService.setSelectedLead(rowDetail.processCodeDetailId);
      this.claimsService.fetchClaimsData(
          program?.program_code ?? '',
          rowDetail.processCodeDetailId,
          'processCode'
        )
        .subscribe((data: any) => {
          this.claimsService.setFormData('process_code', data.responsedata);
          setTimeout(() => {
            this.router.navigate(['/home/processCode', 'update']);
          }, 200);
        });
  }

  private setPageAccess() {
    const authConfig = this.allowListStore.getConfig();
    if (authConfig && !authConfig.pages[this.pageId]) {
      this.isReadOnly = true;
    }
    this.isPageRestrictionLoaded = true;
  }
}
